export enum Size {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  X_LARGE = 'X_LARGE',
  X_SMALL = 'X_SMALL'
}

export type ButtonSize = Extract<
  Size,
  Size.X_SMALL | Size.SMALL | Size.MEDIUM | Size.LARGE
>;
